<template>
  <div class="jl-auc-description">
    <div class="jl-auc-descriptio-video" v-if="videourl">
      <video id="myVideo" class="video-js" controls preload="auto">
        <source :src="videourl" type="video/mp4" />
      </video>
      <!-- <video id="video1" controls="controls">
        <source :src="videourl" type="video/mp4" />
      </video>-->
    </div>
    <div v-html="describe"></div>
  </div>
</template>

<script>
export default {
  props: {
    describe: {
      type: String,
      default: ''
    },
    videourl: {
      type: String,
      default: ''
    }
  },
  updated() {
    this.$nextTick(() => {
      if(this.videourl){
        this.initVideo();
      }
      
    });
  },
  methods: {
    initVideo() {
      //初始化视频方法
      var myVideo = document.getElementById('myVideo');
      let myPlayer = this.$video(myVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        autoplay: 'autoplay',
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: 'auto',
        //设置视频播放器的显示宽度（以像素为单位）
        width: '1160px',
        //设置视频播放器的显示高度（以像素为单位）
        height: '500px'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-description {
  img {
    display: block;
    width: 100%;
  }
}
.jl-auc-descriptio-video {
  margin-top: 30px;
  margin-bottom: 30px;
}
.jl-auc-descriptio-video #video1 {
  display: block;
  width: 100%;
}
</style>
